<template>
  <Badge v-if="badge" :value="badge" :severity="badgeSeverity" class="inline-flex">
    <Avatar
      :label="label"
      :icon="icon"
      :image="image"
      :size="size"
      :shape="shape"
      :class="className"
      :style="style"
    >
      <slot></slot>
    </Avatar>
  </Badge>
  <Avatar
    v-else
    :label="label"
    :icon="icon"
    :image="image"
    :size="size"
    :shape="shape"
    :class="className"
    :style="style"
  >
    <slot></slot>
  </Avatar>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import Avatar from 'primevue/avatar'
import Badge from 'primevue/badge'
import type { MOPAvatarProps } from './types'

export default defineComponent({
  name: 'MOPAvatar',
  components: {
    Avatar,
    Badge
  },
  inheritAttrs: false
})
</script>

<script setup lang="ts">
const props = withDefaults(defineProps<MOPAvatarProps>(), {
  label: undefined,
  icon: undefined,
  image: undefined,
  size: undefined,
  shape: 'square',
  badge: undefined,
  badgeSeverity: 'danger',
  className: undefined,
  style: undefined
})
</script>
